import React, { useMemo } from 'react';
import { bool } from 'prop-types';
import * as styles from './styles/styles.module.scss';
import CommunityStat from './CommunityStat';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const {
  strings: {
    HOME_PAGE: {
      COMMUNITY_STATS_BLOCK: {
        TWO_HUNDRED_K,
        TWENTY_FIVE_MIL,
        TWO_HUNDRED_FOURTEEN_MIL_MILES,
        THREE_HUNDRED_FOURTY_MIL_KILOMETERS,
        CURATED_TRAILS,
        DISCOVER_UNEXPECTED_GEMS,
        FELLOW_EXPLORERS,
        SHARE_YOUR_ADVENTURES,
        LOGGED_MILES,
        LOGGED_KILOMETERS,
        NAVIGATE_YOUR_WAY
      }
    }
  }
} = StringConstantsMixin;

const CommunityStats = ({ displayMetric }) => {
  const [totalDistanceString, loggedDistanceMeasurement] = useMemo(() => {
    return displayMetric ? [THREE_HUNDRED_FOURTY_MIL_KILOMETERS, LOGGED_KILOMETERS] : [TWO_HUNDRED_FOURTEEN_MIL_MILES, LOGGED_MILES];
  }, [displayMetric]);

  return (
    <div className={styles.container}>
      <CommunityStat className={styles.communityStat} title={TWO_HUNDRED_K} subtitle={CURATED_TRAILS} text={DISCOVER_UNEXPECTED_GEMS} />
      <CommunityStat className={styles.communityStat} title={TWENTY_FIVE_MIL} subtitle={FELLOW_EXPLORERS} text={SHARE_YOUR_ADVENTURES} />
      <CommunityStat className={styles.communityStat} title={totalDistanceString} subtitle={loggedDistanceMeasurement} text={NAVIGATE_YOUR_WAY} />
    </div>
  );
};

CommunityStats.propTypes = {
  displayMetric: bool
};

CommunityStats.defaultProps = {
  displayMetric: false
};

export default CommunityStats;
